/**
 * Lectura/escritura de RBAC y almacén en el perfil de sesión en memoria (sessionProfileStore).
 * No escribe cookies del cliente; la autorización real la hace platform-admin-backend.
 */

import {
  getSessionProfile,
  mergeSessionProfile,
  loadSessionField
} from './sessionProfileStore'

export function getRbacIsAdmin() {
  const value = loadSessionField('rbac_is_admin')
  return value === true || value === 'true'
}

export function getCanManageRbac() {
  const value = loadSessionField('can_manage_rbac')
  return value === true || value === 'true' || getRbacIsAdmin()
}

export function getRbacPermissions() {
  const value = loadSessionField('rbac_permissions')
  return Array.isArray(value) ? value : []
}

export function getRbacRoles() {
  const value = loadSessionField('rbac_roles')
  return Array.isArray(value) ? value : []
}

export function getUserWarehouse() {
  const uid = loadSessionField('warehouse_uid')
  if (!uid) return null

  return {
    uid,
    name: loadSessionField('warehouse_name') || uid
  }
}

export function saveUserWarehouseToProfile({ warehouse_uid, warehouse_name } = {}) {
  mergeSessionProfile({
    warehouse_uid: warehouse_uid ?? null,
    warehouse_name: warehouse_name ?? null
  })
}

export function clearUserWarehouseFromProfile() {
  mergeSessionProfile({ warehouse_uid: null, warehouse_name: null })
}

export function saveRbacToProfile({
  rbac_permissions,
  rbac_roles,
  rbac_is_admin,
  can_manage_rbac,
  warehouse_uid,
  warehouse_name
}) {
  const patch = {}
  if (rbac_is_admin !== undefined) {
    patch.rbac_is_admin = !!rbac_is_admin
  }
  if (rbac_permissions !== undefined) {
    patch.rbac_permissions = rbac_permissions
  }
  if (rbac_roles !== undefined) {
    patch.rbac_roles = rbac_roles
  }
  if (can_manage_rbac !== undefined || rbac_is_admin !== undefined) {
    patch.can_manage_rbac =
      can_manage_rbac !== undefined ? !!can_manage_rbac : !!rbac_is_admin
  }
  if (warehouse_uid !== undefined || warehouse_name !== undefined) {
    patch.warehouse_uid = warehouse_uid
    patch.warehouse_name = warehouse_name
  }
  mergeSessionProfile(patch)
}

export function clearRbacFromProfile() {
  mergeSessionProfile({
    rbac_permissions: [],
    rbac_roles: [],
    rbac_is_admin: false,
    can_manage_rbac: false,
    warehouse_uid: null,
    warehouse_name: null
  })
}

export async function refreshRbacFromCurrentUser(fetchCurrentUser) {
  const data = await fetchCurrentUser()
  saveRbacToProfile({
    rbac_permissions: data.rbac_permissions || [],
    rbac_roles: data.rbac_roles || [],
    rbac_is_admin: !!data.rbac_is_admin,
    can_manage_rbac: !!data.can_manage_rbac || !!data.rbac_is_admin,
    warehouse_uid: data.warehouse_uid,
    warehouse_name: data.warehouse_name
  })
  return data
}

export function getRbacSnapshot() {
  const profile = getSessionProfile() || {}
  return {
    rbac_permissions: profile.rbac_permissions || [],
    rbac_roles: profile.rbac_roles || [],
    rbac_is_admin: !!profile.rbac_is_admin,
    can_manage_rbac: !!profile.can_manage_rbac
  }
}
